<template>
    <div class="sk-odds">
        <div
            v-for="(group, groupIndex) in SK_ODDS_GROUPS"
            v-bind:key="groupIndex"
            class="sk-group"
            v-bind:class="{ _narrow: group.narrow }"
        >
            <div class="sk-group-title">
                <div class="sk-group-title-bar" />
            </div>
            <div
                v-for="row in rowCount"
                v-bind:key="row"
                class="sk-row"
            >
                <div class="sk-row-key">
                    <div class="sk-row-key-dot" />
                </div>
                <div
                    v-for="cell in group.cellCount"
                    v-bind:key="cell"
                    v-bind:ref="(el) => setCellRef(el, row, groupIndex, cell)"
                    class="sk-cell"
                >
                    <div class="sk-cell-label" />
                    <div class="sk-cell-price" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { ComponentPublicInstance } from 'vue';
    import type { SingleModeBetSlipTutorialSpotlight } from '@/interface/enum';

    interface BlockSpotlight {
        name: SingleModeBetSlipTutorialSpotlight;
        groupIndex: number;
        cell: number;
    }

    const props = withDefaults(defineProps<{
        rowCount: number;
        spotlight?: BlockSpotlight | null;
    }>(), {
        spotlight: null,
    });

    const emit = defineEmits<{
        spotlight: [{ name: SingleModeBetSlipTutorialSpotlight, element: HTMLElement | null }];
    }>();

    const SK_ODDS_GROUPS = [
        { narrow: false, cellCount: 2 },
        { narrow: false, cellCount: 2 },
        { narrow: true, cellCount: 1 },
    ];

    const SPOTLIGHT_ROW = 1;

    function isSpotlightCell(row: number, groupIndex: number, cell: number) {
        return row === SPOTLIGHT_ROW
            && props.spotlight?.groupIndex === groupIndex
            && props.spotlight?.cell === cell;
    }

    function setCellRef(el: Element | ComponentPublicInstance | null, row: number, groupIndex: number, cell: number) {
        if (!props.spotlight || !isSpotlightCell(row, groupIndex, cell)) return;

        emit('spotlight', {
            name: props.spotlight.name,
            element: el instanceof HTMLElement ? el : null,
        });
    }
</script>

<style lang="scss" scoped>
@import "@/scss/components/betSlipTutorial/skeletonOddsBlock";
</style>
